import { render } from "./galleryModal.vue?vue&type=template&id=99914192&scoped=true&ts=true"
import script from "./galleryModal.vue?vue&type=script&lang=ts"
export * from "./galleryModal.vue?vue&type=script&lang=ts"

import "./galleryModal.vue?vue&type=style&index=0&id=99914192&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99914192"]])

export default __exports__